import React, { useState, useEffect, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';

import {
  Wrapper,
  Box,
  Text,
  Item,
  Label,
  Textarea,
  CheckboxLabel,
  Checkbox,
  CheckboxInput,
  CheckboxCheckmark,
  ButtonHolder,
  Emailarea,
  LabelDiv,
  ButtonReadLess,
  Button
} from './WidgetContactForm.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { toast } from 'react-toastify';

const SET_MESSAGE = gql`
  mutation SET_MESSAGE($id: Int!, $message: String!, $email: String) {
    sendMessageWidget15(widget_id: $id, message: $message, email: $email) {
      done
    }
  }
`;

function WidgetContactForm({ data = {} }) {
  const intl = useIntl();
  const theme = useTheme();
  const [checkboxState, setCheckboxState] = useState(false);
  let messageRef = useRef();
  let messageEmail = useRef();
  const [
    setMessage,
    { loading: massageLoading, error: massageError, data: massageData }
  ] = useMutation(SET_MESSAGE);

  const handleMessage = (id, message, email) => {
    if (!massageLoading && id && message && email) {
      setMessage({ variables: { id, message, email } });
    }
  };

  useEffect(() => {
    let messageToastId;
    if (massageLoading || massageError || massageData) {
      if (massageLoading) {
        messageToastId = toast.info(
          intl.formatMessage({ id: 'WIDGET_CONTACT_FORM.INFO.SET_MESSAGE' })
        );
      } else if (massageError) {
        messageToastId = toast.error(
          intl.formatMessage({ id: 'WIDGET_CONTACT_FORM.ERROR.SET_MESSAGE' })
        );
      } else if (massageData) {
        messageToastId = toast.success(
          intl.formatMessage({ id: 'WIDGET_CONTACT_FORM.SUCCESS.SET_MESSAGE' })
        );
      }
    }
    return () => {
      if (messageToastId) toast.dismiss(messageToastId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [massageLoading, massageError, massageData]);
  const [showLess, setShowLess] = useState(true);
  return (
    <Wrapper>
      <Box theme={theme.widgetContactForm.box}>
        <Text theme={theme.widgetContactForm.text}>{data.text}</Text>
        <Item theme={theme.widgetContactForm.item}>
          <LabelDiv>
            <Label htmlFor='form_email' style={{ visibility: 'hidden' }}>
              Twój e-mail{' '}
            </Label>
            <Emailarea
              id='form_email'
              placeholder={data.placeholderEmail || 'Twoj email'}
              ref={node => (messageEmail.current = node)}
              type='email'
              theme={theme.widgetContactForm.textarea}
            />
          </LabelDiv>
          <LabelDiv>
            <Label htmlFor='form_text' style={{ visibility: 'hidden' }}>
              Wiadomość:{' '}
            </Label>
            <Textarea
              id='form_text'
              placeholder={data.placeholderMessage || ''}
              ref={node => (messageRef.current = node)}
              type='text'
              theme={theme.widgetContactForm.textarea}
            />
          </LabelDiv>
        </Item>
        <Item theme={theme.widgetContactForm.item}>
          <CheckboxLabel theme={theme.widgetContactForm.checkboxLabel}>
            <Checkbox theme={theme.widgetContactForm.checkbox}>
              <Label htmlFor='regulamin' style={{ visibility: 'hidden' }}>
                {data.agreementText}
              </Label>
              <CheckboxInput
                id='regulamin'
                type='checkbox'
                checked={checkboxState}
                onChange={() => {
                  setCheckboxState(checkboxState ? false : true);
                }}
              />
              <CheckboxCheckmark visible={checkboxState ? true : undefined}>
                <FontAwesomeIcon icon={['fas', 'check']} />
              </CheckboxCheckmark>
            </Checkbox>

            {data.agreementText.length > 85 ? (
              <>
                {showLess === true ? (
                  <>{data.agreementText.slice(0, 85)}</>
                ) : (
                  <>{data.agreementText} </>
                )}
              </>
            ) : (
              <>{data.agreementText}</>
            )}
          </CheckboxLabel>
          <ButtonReadLess
            onClick={() => {
              setShowLess(!showLess);
            }}
          >
            {showLess ? (
              <Text
                style={{ cursor: 'pointer' }}
                theme={theme.widgetContactForm.text}
              >
                .... czytaj więcej
              </Text>
            ) : (
              <Text
                style={{ cursor: 'pointer' }}
                theme={theme.widgetContactForm.text}
              >
                ...zwiń
              </Text>
            )}
          </ButtonReadLess>
        </Item>
        <ButtonHolder theme={theme.widgetContactForm.buttonHolder}>
          <Button
            theme={theme.widgetContactForm.button}
            onClick={e => {
              let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              e.preventDefault();
              if (
                messageRef.current.value &&
                regEmail.test(messageEmail.current.value) &&
                checkboxState
              ) {
                handleMessage(
                  data.widget_id,
                  messageRef.current.value,
                  messageEmail.current.value
                );

                messageRef.current.value = '';
                messageEmail.current.value = '';
                setCheckboxState(false);
              } else if (!messageRef.current.value) {
                toast.error(
                  intl.formatMessage({
                    id: 'WIDGET_CONTACT_FORM.ERROR.NO_MESSAGE'
                  })
                );
              } else if (!messageEmail.current.value) {
                toast.error(
                  intl.formatMessage({
                    id: 'WIDGET_CONTACT_FORM.ERROR.NO_EMAIL'
                  })
                );
              } else if (!regEmail.test(messageEmail.current.value)) {
                toast.error(
                  intl.formatMessage({
                    id: 'WIDGET_CONTACT_FORM.ERROR.WRONG_EMAIL'
                  })
                );
              } else if (!checkboxState) {
                toast.error(
                  intl.formatMessage({
                    id: 'WIDGET_CONTACT_FORM.ERROR.NO_AGREEMENT'
                  })
                );
              }
            }}
          >
            <FormattedMessage id='WIDGET_CONTACT_FORM.SEND' />
          </Button>
        </ButtonHolder>
      </Box>
    </Wrapper>
  );
}

export default WidgetContactForm;
